import axios from "axios";
import store from "@/store";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {queryBuilder, filters} from '../class/QueryFilter'
import {checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

let filtersCopy = JSON.parse(JSON.stringify(filters))

const reshapeForm = (form) => {
    let formData = new FormData();
    // feature
    formData.append('name', form.name);
    formData.append('public_name', form.public_name);
    formData.append('type', form.type);
    formData.append('language_id', form.language_id);
    formData.append('order', form.order);


    if (form.featureImage != undefined && form.featureImage.length !== 0) {
        formData.append(`image`, form.featureImage);
    }

    // feature attribute
    form.feature_attributes.forEach((item, index) => {
        if (item.featureImage != undefined && item.featureImage.length !== 0) {
            formData.append(`feature_attributes[${index}][image]`, item.image);
        }
        if (checkValueIsNumber(item.id)) {
            formData.append(`feature_attributes[${index}][id]`, item.id);
        }
        formData.append(`feature_attributes[${index}][filterable]`, item.filterable == false ? 0 : 1);
        formData.append(`feature_attributes[${index}][value]`, item.value);

    })

    return formData;
};


export const featureTypes = [
    {value: 'text', text: 'متن'},
    {value: 'list', text: 'لیست'},
    {value: 'checkbox', text: 'چند گزینه ای'},
    {value: 'radio', text: 'تک گزینه ای'},
    {value: 'switch', text: 'دوحالته'},
    {value: 'number', text: 'عدد'},
    {value: 'date', text: 'تاریخ'},
    {value: 'list-step', text: 'لیست مرحله ای'},
    {value: 'checkbox-step', text: 'لیست مرحله ای چند انتخابه'},
    {value: 'variable', text: 'متغییر'},
    {value: 'formula', text: 'فرمول'},
    {value: 'list-with-number-value', text: 'ویژگی لیستی با مقدار عددی'},
    {value: 'list-with-text-value', text: 'ویژگی لیستی با مقدار متنی'},
    {value: 'link', text: 'لینک'},
    {value: 'map', text: 'نقشه'},
]

export const unFilteredFeatureTypes = ['text', 'number', 'date', 'variable', 'formula', 'link', 'map']

export default {
    namespaced: true,
    state: {
        features: [],
        links: {},
        meta: {},
        searchWord: null,
        filteredFeatures: [],
        trash: [],
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
        setFeatures(state, features) {
            state.features = features;
        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        deleteFeature(state, feature) {
            state.features = state.features.filter((f) => f.id !== feature.id);
        },
        setfilteredFeatures(state, filteredFeatures) {
            state.filteredFeatures = filteredFeatures;
        },
        destroyFearure: (state, feature) => {
            state.features.splice(
                findObjectIndex(store.getters["Feature/getFeatures"], feature),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["Feature/getTrash"], feature),
                1
            );
        },
        setTrash(state, features) {
            state.trash = features;
        },
    },
    actions: {
        getFeatures({state, commit}, page = 1) {
            return new Promise((resolve, reject) => {
                // convert filter items to query string
                const query = queryBuilder(state.filters)
                let req = axios.get(`/feature?page=${page}&${query}`)
                req.then((response) => {
                    response = response.data.data;
                    commit("setFeatures", response.data);
                    commit("setfilteredFeatures", response.data);
                    commit("setLinks", response.links);
                    commit("setMeta", response.meta);
                    resolve(response);
                })
                    .catch((error) => {
                        reject(error);
                    });
                return req
            });
        },
        async getFeature({commit}, form) {
            return await axios.get(`feature/${form.id}`);
        },
        createFeature({commit}, form) {

            let req = axios.post("/feature", reshapeForm(form));


            req.then((response) => {
                const feature = response.data.data;
                const features = {
                    ...store.getters["Feature/getFeatures"],
                    ...feature,
                };
                commit("setFeatures", features);
                router.push({name: "UpdateFeature", params: {id: feature.id}});
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        updateFeature({commit}, form) {
            const formData = reshapeForm(form);
            formData.append('_method', 'PUT')
            let req = axios.post(`/feature/${form.id}`, formData);

            req.then((response) => {
                const feature = response.data.data;
                const features = {
                    ...store.getters["Feature/getFeatures"],
                    ...feature,
                };
                commit("setFeatures", features);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        filteredFeatures({commit}, word) {
            axios
                .post("/feature/search", word)
                .then((res) => {
                    const feature = res.data.data.data;
                    commit("setfilteredFeatures", feature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeFeature({commit}, feature) {
            axios
                .delete(`/feature/${feature.id}`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    commit("destroyFearure", deletedFeature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeFeatureAttribute({commit}, form) {
            axios
                .delete(`feature-attributes/delete/feature-attribute/${form.feature_attribute_id}`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        trashFeatures({commit}, page = 1) {
            axios
                .post(`/feature/trash?page=${page}`)
                .then((res) => {
                    const trashItems = res.data.data.data;
                    commit("setTrash", trashItems);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreFeature({commit}, feature) {
            axios
                .put(`/feature/${feature.id}/restore`)
                .then((res) => {
                    const restoredFeature = res.data.data;
                    commit("destroyFearure", restoredFeature);
                    const features = {
                        ...store.getters["Feature/getFeatures"],
                        restoredFeature,
                    };
                    commit("setFeatures", features);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDeleteFeature({commit}, feature) {
            axios
                .delete(`/feature/${feature.id}/force-delete`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    commit("destroyFearure", deletedFeature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        archiveFilterFeatures({state, commit}) {
            const query = queryBuilder(state.filters)
            return axios.get(`archive/filter/features?${query}`)
        },
        removeFeatureImage({state, commit}, form) {
            return axios.post(`feature/remove-image/${form.id}`)
        },
        removeFeatureAttributeImage({state, commit}, form) {
            return axios.post(`feature-attribute/remove-image/${form.id}`)
        },
        async getSingleFeatureWithoutAuthentication({commit}, form) {
            return await axios.get(`/get-single-feature-attributes/${form.id}`);
        },
    },
    getters: {
        getFeatures: (state) => state.features,
        getPaginationLinks: (state) => state.links,
        getPaginationMeta: (state) => state.meta,
        getFilteredFeatures: (state) => state.filteredFeatures,
        getTrash: (state) => state.trash,
        getFilter: (state) => (key) => {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                return state.filters[key];
            }
        },
        getFilters: (state) => state.filters

    },
};
